export default __webpack_public_path__ + "static/media/Selected_Ticket.dc38959e.svg";